import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BarChart } from '@mui/x-charts/BarChart';
import { Card, CardHeader, Grid } from '@mui/material';
import { getFlaggedAnalytics } from 'src/services/analytics.service';
import { PieChart } from '@mui/x-charts';
import AppSimpleBarChart from 'src/sections/@dashboard/app/AppSimpleBarChart';
import AppSimpleHorizontalBarChart from 'src/sections/@dashboard/app/AppSimpleHorizontalBarChart';

class FlaggedAnalytics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            by_count: [],
            by_size: [],
            by_count_chart_data: {
                xAxisData: [],
                seriesData: []
            },
            by_count_horizontal_chart_data: [],
            by_count_pie_chart_data: {
                seriesData: []
            },
            by_size_chart_data: {
                xAxisData: [],
                seriesData: []
            },
            by_size_horizontal_chart_data: [],
            by_size_pie_chart_data: {
                seriesData: []
            }
        }
    }

    async componentDidMount() {

        let query = null;
        if (this?.props?.user_id) {
            query = {
                user_id: this.props.user_id
            };
        }
        let flagged_analytics = await getFlaggedAnalytics(query);
        
        if (flagged_analytics.error) {
            console.error(flagged_analytics.error);
            return;
        }
        flagged_analytics = flagged_analytics.flagged_analytics;

        let by_count_array = flagged_analytics.by_count || [];
        let by_size_array = flagged_analytics.by_size || [];

        let by_count_chart_data = {
            xAxisData: [],
            seriesData: []
        }

        let by_count_horizontal_chart_data = []

        let by_count_pie_chart_data = {
            seriesData: []
        }

        let by_size_chart_data = {
            xAxisData: [],
            seriesData: []
        }

        let by_size_horizontal_chart_data = []

        let by_size_pie_chart_data = {
            seriesData: []
        }

        for(let i = 0; i < by_count_array.length; i++) {
            let item = by_count_array[i];
            if (i >= 10) {
                break;
            }
            by_count_chart_data.xAxisData.push(item.flags);
            by_count_chart_data.seriesData.push(item.count);
            by_count_horizontal_chart_data.push({
                label: item.flags,
                value: item.count
            });
            by_count_pie_chart_data.seriesData.push({
                label: item.flags,
                value: item.count
            });
        }

        for(let i = 0; i < by_size_array.length; i++) {
            let item = by_size_array[i];
            if (i >= 10) {
                break;
            }
            by_size_chart_data.xAxisData.push(item.flags);
            by_size_chart_data.seriesData.push(item.size / 1024 / 1024);
            by_size_horizontal_chart_data.push({
                label: item.flags,
                value: item.size / 1024 / 1024
            });
            by_size_pie_chart_data.seriesData.push({
                label: item.flags,
                value: item.size / 1024 / 1024
            });
        }

        this.setState({
            by_count: by_count_array,
            by_size: by_size_array,
            by_count_chart_data: by_count_chart_data,
            by_count_horizontal_chart_data: by_count_horizontal_chart_data,
            by_count_pie_chart_data: by_count_pie_chart_data,
            by_size_chart_data: by_size_chart_data,
            by_size_horizontal_chart_data: by_size_horizontal_chart_data,
            by_size_pie_chart_data: by_size_pie_chart_data
        });

    }

    render() {

        return (
            <>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <AppSimpleHorizontalBarChart
                            title="Flagged"
                            subheader="by count"
                            chartData={this.state.by_count_horizontal_chart_data}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <AppSimpleHorizontalBarChart
                            title="Flagged"
                            subheader="by size ( in MB )"
                            chartData={this.state.by_size_horizontal_chart_data}
                        />
                    </Grid>
                </Grid>


                {/* {this.state.by_count.length ? (
                    <Card variant='outlined'>
                        <CardHeader title='Flagged ( by count )' />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
                                <PieChart
                                    series={[
                                        {
                                            data: this.state.by_count_pie_chart_data.seriesData,
                                            innerRadius: 30,
                                            outerRadius: 100,
                                            paddingAngle: 6,
                                            cornerRadius: 5,
                                        }
                                    ]}
                                    height={350}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
                                <AppSimpleBarChart
                                    chartLabels={this.state.by_count_chart_data.xAxisData}
                                    chartData={[
                                        {
                                            name: 'Count',
                                            type: 'column',
                                            fill: 'solid',
                                            data: this.state.by_count_chart_data.seriesData,
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                ) : null}
                
                {this.state.by_size.length ? (
                    <Card variant='outlined'>
                        <CardHeader title='Flagged ( by size in MB )' />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
                                <PieChart
                                    series={[
                                        {
                                            data: this.state.by_size_pie_chart_data.seriesData,
                                            innerRadius: 30,
                                            outerRadius: 100,
                                            paddingAngle: 6,
                                            cornerRadius: 5,
                                        }
                                    ]}
                                    height={350}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
                                <AppSimpleBarChart
                                    chartLabels={this.state.by_size_chart_data.xAxisData}
                                    chartData={[
                                        {
                                            name: 'Size',
                                            type: 'column',
                                            fill: 'solid',
                                            data: this.state.by_size_chart_data.seriesData.map((item) => { return item.toFixed(2); })
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                ) : null} */}
            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <FlaggedAnalytics {...props} navigate={navigate} params={params} />;
}
